import { render, staticRenderFns } from "./akManage.vue?vue&type=template&id=504b5a98&scoped=true&"
import script from "./akManage.vue?vue&type=script&lang=js&"
export * from "./akManage.vue?vue&type=script&lang=js&"
import style0 from "./akManage.vue?vue&type=style&index=0&id=504b5a98&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504b5a98",
  null
  
)

export default component.exports